var productFormSelector = 'form[action*="cart/add"].product-buy-form-pdp';

function Elixir_ProductFormExists() {
    return document.querySelector(productFormSelector) !== null;
}

function Elixir_GetProductForm() {
    return document.querySelector(productFormSelector);
}

// Returns the variant ID from the product form (input[name="id"]), if it exists.
function Elixir_GetProductFormVariantId() {
    var form = Elixir_GetProductForm();
    if (!form) return null;
    var input = form.querySelector('input[name="id"]');
    return input && input.value ? input.value : null;
}

function Elixir_SetProductFormVariantId(variantId) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    var input = form.querySelector('input[name="id"]');
    if (input) {
        input.value = variantId !== undefined && variantId !== null && variantId !== '' ? String(variantId) : '';
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') return true;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    return true;
}

function Elixir_ProductFormSwitchToItemsMode(items, options) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    if (!items || !Array.isArray(items) || items.length === 0) return false;

    options = options || {};
    var containerClass = options.containerClass || 'product-form-items-container';
    var startIndex = options.startIndex !== undefined ? options.startIndex : 1;

    var existing = form.querySelector('.' + containerClass);
    if (existing) existing.remove();

    var container = document.createElement('div');
    container.className = containerClass;

    items.forEach(function (item, i) {
        var index = startIndex + i;
        var idIn = document.createElement('input');
        idIn.type = 'hidden';
        idIn.name = 'items[' + index + '][id]';
        idIn.value = String(item.id);
        idIn.className = 'product-variant-id';
        container.appendChild(idIn);

        var qtyIn = document.createElement('input');
        qtyIn.type = 'hidden';
        qtyIn.name = 'items[' + index + '][quantity]';
        qtyIn.value = String(item.quantity != null ? item.quantity : 1);
        container.appendChild(qtyIn);

        if (item.selling_plan != null && item.selling_plan !== '') {
            var planIn = document.createElement('input');
            planIn.type = 'hidden';
            planIn.name = 'items[' + index + '][selling_plan]';
            planIn.value = String(item.selling_plan);
            container.appendChild(planIn);
        }

        if (item.properties && typeof item.properties === 'object') {
            Object.keys(item.properties).forEach(function (key) {
                var propIn = document.createElement('input');
                propIn.type = 'hidden';
                propIn.name = 'items[' + index + '][properties][' + key + ']';
                propIn.value = String(item.properties[key]);
                container.appendChild(propIn);
            });
        }
    });

    var mainIdInput = form.querySelector('input[name="id"]');
    if (mainIdInput) mainIdInput.remove();

    form.appendChild(container);
    return true;
}

function Elixir_ProductFormSwitchToSingleIdMode(variantId, itemsContainerSelector) {
    var form = Elixir_GetProductForm();
    if (!form) return false;

    if (itemsContainerSelector) {
        var container = form.querySelector(itemsContainerSelector);
        if (container && (variantId === undefined || variantId === null || variantId === '')) {
            var firstIdInput = container.querySelector('input[name^="items["][name*="][id]"]');
            if (firstIdInput && firstIdInput.value) variantId = firstIdInput.value;
        }
        if (container) container.remove();
    }

    var input = form.querySelector('input[name="id"]');
    if (input) {
        if (variantId !== undefined && variantId !== null && variantId !== '') input.value = String(variantId);
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') return true;

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    return true;
}

/* ---------------------------------------------------------------------------
   Skip to checkout: put the last step back.

   The product page already carries a complete skipToCheckout(), inline in
   sections/shop-product-details.liquid. It builds the whole bundle - paid units
   with the selling plan, free units marked _bundle_free, and the gift - into a
   single /cart/add.js, and every path it can take ends at goCheckout(). Only
   that last function changed when the theme became "ATC no CC": instead of
   navigating it now refreshes the drawer. Its own comment says so.

   Nothing here edits that file, and that is deliberate: the original code stays
   exactly as it is, as the fallback. Remove this block and the theme is back to
   opening the drawer, with no other trace left behind.

   Why this is not a copy of the bundle logic:

   goCheckout is a closure and cannot be replaced directly, but it reaches the
   outside world exactly once - through drawer.refreshCartDrawer(state). That
   call is the seam. skipToCheckout is wrapped only to record that a checkout
   run started; none of its logic is duplicated, so the bundle building stays
   the single source of truth and this cannot drift away from it.

   Kill switch: set window.__skipToCheckoutOff = true (or add ?nocheckoutskip=1
   to the URL) and the drawer behaviour returns immediately, without a deploy.
   --------------------------------------------------------------------------- */
(function () {
  var WINDOW_MS = 10000;

  function disabled() {
    if (window.__skipToCheckoutOff) return true;
    try { return location.search.indexOf('nocheckoutskip=1') !== -1; } catch (_e) { return false; }
  }

  function checkoutUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/+$/, '') + '/checkout';
  }

  /* -------------------------------------------------------------------------
     Do not ask for `sections` on the way to checkout.

     bundle-gifts.js injects the configured free gifts into the /cart/add
     request itself, but it refuses any request carrying `sections`: that shape
     belongs to the drawer, which needs the sections response back in order to
     render. For those it falls back to its cart watcher instead.

     That fallback is fine when the drawer opens. It is not fine when we are
     leaving. Measured on the live storefront: the watcher's add lands ~2.2s
     after the click while the redirect goes at ~0.5s, so the customer reaches
     checkout without the gift.

     In practice this is the Buy 1 option and nothing else. The bundle tiers
     already post JSON items, which bundle-gifts rewrites happily; only the
     single-unit path posts a FormData with sections on it.

     Installed when skipToCheckout runs rather than at load, so it sits outside
     bundle-gifts.js's own fetch wrapper whichever script loaded first: we clean
     the request, then hand it to them to fill.
     ------------------------------------------------------------------------- */
  var stripInstalled = false;

  function installSectionStrip() {
    if (stripInstalled || typeof window.fetch !== 'function') return;
    stripInstalled = true;
    var inner = window.fetch;
    window.fetch = function (input, init) {
      var isAdd = false;
      try {
        var url = String((input && input.url) || input || '');
        isAdd = url.indexOf('/cart/add') !== -1;
        var started = window.__skipToCheckoutAt || 0;
        var inFlight = started && Date.now() - started < WINDOW_MS;
        if (isAdd && inFlight && !disabled() &&
            init && init.body && typeof FormData !== 'undefined' && init.body instanceof FormData &&
            (init.body.has('sections') || init.body.has('sections_url'))) {
          var clean = new FormData();
          init.body.forEach(function (v, k) {
            if (k !== 'sections' && k !== 'sections_url') clean.append(k, v);
          });
          var copy = {};
          for (var key in init) {
            if (Object.prototype.hasOwnProperty.call(init, key)) copy[key] = init[key];
          }
          copy.body = clean;
          init = copy;
        }
      } catch (_e) { /* on any doubt, send the request untouched */ }
      var p = inner.call(this, input, init);
      /* The redirect hangs off this line: a checkout we send somebody to has
         to be one their items actually reached. */
      if (isAdd) {
        try {
          p.then(function (r) { if (r && r.ok) window.__skipAddOk = Date.now(); }, function () {});
        } catch (_e2) { /* noop */ }
      }
      return p;
    };
  }

  function wrapSkip() {
    var orig = window.skipToCheckout;
    if (typeof orig !== 'function' || orig.__redirectPatched) return;
    var wrapped = function () {
      window.__skipToCheckoutAt = Date.now();
      window.__skipAddOk = 0;
      installSectionStrip();
      return orig.apply(this, arguments);
    };
    wrapped.__redirectPatched = true;
    wrapped.__original = orig;
    window.skipToCheckout = wrapped;
  }

  function wrapDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.refreshCartDrawer !== 'function') return;
    if (drawer.refreshCartDrawer.__redirectPatched) return;
    var orig = drawer.refreshCartDrawer;
    var wrapped = function () {
      var started = window.__skipToCheckoutAt || 0;
      var addOk = window.__skipAddOk || 0;
      /* Leave only once an add has come back OK for this run. A drawer refresh
         firing for any other reason inside the window - a failed add, then
         something else touching the drawer - would otherwise send the customer
         to an empty /checkout, and Shopify bounces an empty checkout to the
         homepage. That is a lost sale wearing a redirect as a disguise. */
      if (!disabled() && started && addOk >= started && Date.now() - started < WINDOW_MS) {
        window.__skipToCheckoutAt = 0;
        window.__skipAddOk = 0;
        window.location.href = checkoutUrl();
        return;
      }
      return orig.apply(this, arguments);
    };
    wrapped.__redirectPatched = true;
    wrapped.__original = orig;
    drawer.refreshCartDrawer = wrapped;
  }

  function apply() {
    try { wrapSkip(); wrapDrawer(); } catch (_e) { /* never break the PDP */ }
  }

  if (document.readyState !== 'loading') apply();
  else document.addEventListener('DOMContentLoaded', apply);
  /* The inline definition and the cart-drawer element each arrive on their own
     schedule; re-applying is free because both wrappers are idempotent. */
  setTimeout(apply, 800);
  setTimeout(apply, 2500);
})();
